import type { Client } from '../../types';

export type DerivedClientStatus =
  | 'activo'
  | 'pendiente'
  | 'moroso'
  | 'suspendido'
  | 'inactivo';

export const CLIENT_STATUS_LABELS: Record<DerivedClientStatus, string> = {
  activo: 'Activo',
  pendiente: 'Pendiente',
  moroso: 'Moroso',
  suspendido: 'Suspendido',
  inactivo: 'Inactivo'
};

type PlanLike = {
  status?: string;
  invoices?: { status?: string }[];
};

function collectPlans(client: Client): PlanLike[] {
  const raw = (client as Client & { clientPlans?: PlanLike[] }).clientPlans;
  if (raw && raw.length) return raw;
  return (client.plans as PlanLike[]) || [];
}

function hasOverdueInvoice(client: Client): boolean {
  const plans = collectPlans(client);
  for (const p of plans) {
    const invs = p.invoices || [];
    for (const inv of invs) {
      if (inv.status === 'OVERDUE') return true;
    }
  }
  return false;
}

/**
 * Estado operativo derivado de plan + facturas (sin campo dedicado en BD).
 * Prioridad: sin plan → moroso (facturas) → estado del plan → activo.
 */
export function deriveClientStatus(client: Client): DerivedClientStatus {
  const plans = collectPlans(client);
  if (!plans.length) return 'pendiente';

  const primary = plans[0];
  const planStatus = String(primary.status || 'active').toLowerCase();

  if (planStatus === 'completed') return 'inactivo';
  if (planStatus === 'inactive') return 'suspendido';
  if (hasOverdueInvoice(client)) return 'moroso';
  if (planStatus === 'active') return 'activo';
  return 'activo';
}
